import ProductTypeOptionCombinations from './ProductTypeOptionCombinations';

export default ProductTypeOptionCombinations;
